"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const decorators_js_1 = require("lit/decorators.js");
const lit_1 = require("lit");
const lit_html_1 = require("lit-html");
const class_map_js_1 = require("lit-html/directives/class-map.js");
const control_1 = require("./control");
const ref_js_1 = require("lit-html/directives/ref.js");
/**
 * Текстовое поле
 */
let TextField = class TextField extends lit_1.LitElement {
    /**
     * Конструктор
     */
    constructor() {
        super();
        /**
         * Наличие значения
         */
        this.hasValue = false;
        /**
         * Ошибка
         */
        this.error = '';
        /**
         * Надпись
         */
        this.placeholder = '';
        /**
         * Имя поля
         */
        this.name = '';
        /**
         * Тип
         */
        this.type = 'text';
        /**
         * Блокировка поля
         */
        this.disabled = false;
        /**
         * Label
         */
        this.labelText = '';
        /**
         * Элемент ввода
         */
        this.inputRef = (0, ref_js_1.createRef)();
        this.keyup = this.keyup.bind(this);
        this.input = this.input.bind(this);
        this.paste = this.paste.bind(this);
    }
    /**
     * Обрабатывает событие инициализации
     */
    connectedCallback() {
        var _a, _b, _c;
        super.connectedCallback();
        this.hasValue = !!((_a = this.control) === null || _a === void 0 ? void 0 : _a.getValue());
        (_b = this.control) === null || _b === void 0 ? void 0 : _b.registerOnError(() => {
            var _a;
            this.error = ((_a = this.control) === null || _a === void 0 ? void 0 : _a.getError()) || '';
        });
        (_c = this.control) === null || _c === void 0 ? void 0 : _c.registerOnChange(() => {
            var _a;
            this.hasValue = !!((_a = this.control) === null || _a === void 0 ? void 0 : _a.getValue());
        });
    }
    /**
     * Устанавливает корень структуры
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Возвращает представление
     */
    render(...props) {
        var _a, _b;
        const required = this.required && !this.labelText
            ? this.hasValue
                ? null
                : (0, lit_html_1.html) `<div class="d-block field__placeholder">${this.placeholder}<span>*</span></div>`
            : null;
        if (this.type === 'textarea') {
            return (0, lit_html_1.html) `
                <div class="input-group h-100">
                    <textarea
                        ${(0, ref_js_1.ref)(this.inputRef)}
                        type="${this.type}"
                        class="art-uikit form-control ${(0, class_map_js_1.classMap)({ 'is-invalid': !!this.error })}"
                        name="${this.name}"
                        placeholder="${this.required ? '' : this.placeholder}"
                        @input=${this.input}
                        @paste=${this.paste}
                        value="${(_a = this.control) === null || _a === void 0 ? void 0 : _a.getValue()}"
                        ?disabled="${this.disabled}"
                    ></textarea>
                    ${required}
                    <div class="art-uikit invalid-feedback">
                        <span class="text">${this.error}</span>
                    </div>
                </div>
            `;
        }
        const prefix = this.pref
            ? (0, lit_html_1.html) `<div class="input-group-prefix">${this.pref}</div>`
            : null;
        const postfix = this.postfix
            ? (0, lit_html_1.html) `<div class="input-group-postfix">${this.postfix}</div>`
            : null;
        const label = this.labelText
            ? (0, lit_html_1.html) `<label class="input-label">${this.labelText} ${this.required ? '*' : ''}</label>`
            : null;
        return (0, lit_html_1.html) `
            <div class="${(0, class_map_js_1.classMap)({ 'input-group': true, 'input-group-compose': !!this.pref || !!this.postfix })}">
                ${prefix}
                ${label}
                <input
                    ${(0, ref_js_1.ref)(this.inputRef)}
                    type="${this.type}"
                    class="art-uikit form-control ${(0, class_map_js_1.classMap)({ 'is-invalid': !!this.error })}"
                    name="${this.name}"
                    placeholder="${this.required && !this.labelText ? '' : this.placeholder}"
                    @keyup=${this.keyup}
                    @input=${this.input}
                    @paste=${this.paste}
                    value="${(_b = this.control) === null || _b === void 0 ? void 0 : _b.getValue()}"
                    ?disabled="${this.disabled}"
                >
                ${required}
                ${postfix}
                <div class="invalid-feedback">
                    <span class="text">${this.error}</span>
                </div>
            </div>
        `;
    }
    /**
     * Обрабатывает событие вставки
     */
    paste(e) {
        setTimeout(() => this.input(e));
    }
    /**
     * Обрабатывает ввод
     */
    keyup(e) {
        if (e.key === 'Enter') {
            this.dispatchEvent(new CustomEvent('enter'));
        }
    }
    /**
     * Обрабатывает ввод
     */
    input(e) {
        var _a, _b, _c;
        const charCode = (e.which) ? e.which : e.keyCode;
        const keyChar = String.fromCharCode(charCode);
        if (!this.inputRef.value) {
            return;
        }
        if (this.error) {
            (_a = this.control) === null || _a === void 0 ? void 0 : _a.resetError();
        }
        let rawInput = this.inputRef.value.value;
        if (this.pattern && ((_b = this.pattern) === null || _b === void 0 ? void 0 : _b.test(keyChar))) {
            rawInput = this.inputRef.value.value.replace(this.pattern, '');
            this.inputRef.value.value = rawInput;
        }
        (_c = this.control) === null || _c === void 0 ? void 0 : _c.setValue(rawInput);
    }
};
__decorate([
    (0, decorators_js_1.state)(),
    __metadata("design:type", Boolean)
], TextField.prototype, "hasValue", void 0);
__decorate([
    (0, decorators_js_1.property)(),
    __metadata("design:type", String)
], TextField.prototype, "error", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String }),
    __metadata("design:type", String)
], TextField.prototype, "placeholder", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String }),
    __metadata("design:type", String)
], TextField.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String }),
    __metadata("design:type", String)
], TextField.prototype, "type", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: control_1.Control }),
    __metadata("design:type", control_1.Control)
], TextField.prototype, "control", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: RegExp }),
    __metadata("design:type", RegExp)
], TextField.prototype, "pattern", void 0);
__decorate([
    (0, decorators_js_1.property)(),
    __metadata("design:type", Boolean)
], TextField.prototype, "disabled", void 0);
__decorate([
    (0, decorators_js_1.property)(),
    __metadata("design:type", Object)
], TextField.prototype, "pref", void 0);
__decorate([
    (0, decorators_js_1.property)(),
    __metadata("design:type", Object)
], TextField.prototype, "postfix", void 0);
__decorate([
    (0, decorators_js_1.property)(),
    __metadata("design:type", Boolean)
], TextField.prototype, "required", void 0);
__decorate([
    (0, decorators_js_1.property)(),
    __metadata("design:type", String)
], TextField.prototype, "labelText", void 0);
TextField = __decorate([
    (0, decorators_js_1.customElement)('art-text-field'),
    __metadata("design:paramtypes", [])
], TextField);
